export default __webpack_public_path__ + "static/education-24e9baf190a9381c63721c0637eb41a9.png";